import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { MarkdownText } from '../..';
type PreviewModeProps = {
  value: string;
  height: number;
  maxHeight: number;
  hasError: boolean;
};
const PreviewMode = t0 => {
  const $ = _c(12);
  const {
    value,
    height,
    maxHeight,
    hasError
  } = t0;
  const t1 = !hasError;
  let t2;
  if ($[0] !== hasError || $[1] !== t1) {
    t2 = cx("w-full px-3 py-2 rounded-md border border-solid bg-secondary overflow-auto", "text-body-2 text-primary", {
      "border-error": hasError,
      "border-tertiary": t1
    });
    $[0] = hasError;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== height || $[4] !== maxHeight) {
    t3 = {
      minHeight: height,
      maxHeight
    };
    $[3] = height;
    $[4] = maxHeight;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== value) {
    t4 = value ? <MarkdownText>{value}</MarkdownText> : <span className="text-tertiary italic">Nothing to preview</span>;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className={t2} style={t3}>{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default PreviewMode;